import {AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import {MenuItem, PrimeNGConfig} from "primeng/api";
import {StoreService} from "../../services/store.service";
import {Category} from "../../../interfaces/category";
import {Router} from '@angular/router';
import {MainDataService} from "../../services/main-data.service";
import {CookieService} from 'ngx-cookie-service';
import {AuthTokenService} from '../../services/token.service';
import {AppDataService} from "../../services/app-data.service";
import {Categories} from "../../../interfaces/app";
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})

export class SideMenuComponent implements OnInit, AfterViewInit {
  isShowAll: boolean = environment.isStoreCloud
  display: boolean = false;
  categories: Array<Category> = [];
  mobileCategories: any = [];
  mobileCategoriesStack: any = [];
  lang: string;
  loggedIn = false;
  items: MenuItem[] = [];
  authToken: any = '';
  subCategories: any = [];
  subCategories2: any = [];
  subCategories3: any = [];
  subCatNames: any = ['', '', ''];
  tenantId: string = '1';
  screenWidth: any;

  constructor(
    private primengConfig: PrimeNGConfig,
    private store: StoreService, private router: Router,
    private mainDataService: MainDataService,
    private authTokenService: AuthTokenService,
    private cookieService: CookieService,
    private appDataService: AppDataService,
    private cd: ChangeDetectorRef,
  ) {
    // this.lang = this.store.get('lang') || 'en';
    this.tenantId = localStorage.getItem('tenantId') ?? '1';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }

  ngOnInit() {

    this.primengConfig.ripple = true;
    // this.getLanguage();


    this.getCategories();

  }

  ngAfterViewChecked(): void {
    this.screenWidth = window.innerWidth;
    this.cd.markForCheck();
      this.cd.detectChanges();
    setTimeout(() => {
      this.authTokenService.authTokenData.subscribe(message => this.authToken = message);
      if (!this.authToken) {
        this.authToken = this.cookieService.get('authToken');
      }
      if (this.authToken)
        this.loggedIn = true;
      else
        this.loggedIn = false;
    }, 1);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.authTokenService.authTokenData.subscribe(message => this.authToken = message);
      if (!this.authToken) {
        this.authToken = this.cookieService.get('authToken');
      }
      if (this.authToken)
        this.loggedIn = true;
      else
        this.loggedIn = false;

      this.store.subscription('categories')
        .subscribe({
          next: (res: any) => {
            this.categories = res;
            this.categories?.forEach((cat: any) => {
              cat['path'] = cat.categoryName;
              cat['catIds'] = cat.id;

              this.fetchCategories(cat.categories, cat);
            });


          },
          error: (err: any) => {
            console.error(err);
          }
        });
    }, 1);
  }

  fetchCategories(category: any, cat: any) {

    if (category.length == 0) {
      return;
    }
    for (let i = 0; i < category.length; i++) {
      category[i]['path'] = cat.path + '//' + category[i].categoryName;
      category[i]['catIds'] = cat.catIds + '//' + category[i].id;
      this.fetchCategories(category[i].categories, category[i]);
    }

  }


  openMenu() {
    this.display = true;
  }

  closeMenu(): void {
    this.display = false;
    this.subCategories = [];
    this.subCategories2 = [];
    this.subCategories3 = [];
    this.mobileCategories = this.categories;
    this.mobileCategoriesStack = [];
  }



  logOut(): void {

    this.authTokenService.callLogout().subscribe({
      next: (res: any) => {},
      error: (err)=> {}
    });
    
    this.authToken = null;
    this.loggedIn = false;
    sessionStorage.clear();


    this.authTokenService.authTokenSet("");

    this.cookieService.delete('authToken', '/');
    this.mainDataService.setCartLenghtData(null);
    this.mainDataService.setUserData(null);

    this.store.set('profile', '');
    this.store.set('cartProducts', '');
    localStorage.setItem('sessionId', '');
    localStorage.setItem('addedProducts', '');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('auth_enc');
    this.router.navigate(['/']);
   
  }

  getCategories(): void {
    const categories: Categories = this.appDataService.categories;

    categories.records.forEach((cat: any) => {
      cat['path'] = '';
      cat['catIds'] = '';
      this.fetchCategories(cat.categories, cat);
    });
    categories.records.forEach((category: any) => {
      if (category.categories.length > 0) {
        const subCategories: any = [];
        category.categories.forEach((subCat: any) => {
          subCategories.push({label: subCat.categoryName});
        });

        this.items.push({
          label: category.categoryName,
          items: subCategories
        });
      } else {
        this.items.push({
          label: category.categoryName
        });
      }
    });
    this.mobileCategories = categories.records;
  }

  assignSubCategories(subCat: any, catName: string) {
    this.subCategories = subCat;
    this.subCategories2 = [];
    this.subCatNames[0] = catName;
  }

  assignSubCategories2(subCat: any, catName: string) {
    this.subCategories2 = subCat;
    this.subCategories3 = [];
    this.subCatNames[1] = catName;
  }

  assignSubCategories3(subCat: any, catName: string) {
    this.subCategories3 = subCat;
    this.subCatNames[2] = catName;
  }

  goToCategories(id: any, path: any) {
    let category = path;
    this.router.navigate(['category', id],{
      queryParams: {
        tenantId: localStorage.getItem("tenantId"),
        lang:localStorage.getItem("lang")
      },
      queryParamsHandling: 'merge',
    })
    // if (category.path == '') {
    //   this.router.navigate([`/category/${id}`]);
    // } else {
    //   this.router.navigate([`/category/${id}`], {queryParams: {path: category.path, id: category.catIds}});
    // }
    this.closeMenu();
  }

  selectMobileCategories(category: any) {
    this.mobileCategories = category.categories;
    this.mobileCategoriesStack.push(category);
  }

  async setPreviousMobileCategories() {
    this.mobileCategories = [];
    await this.mobileCategoriesStack.pop();
    if (this.mobileCategoriesStack.length > 0) {
      this.mobileCategories = this.mobileCategoriesStack[this.mobileCategoriesStack.length - 1].categories;
    } else {
      this.mobileCategories = this.categories;
    }
  }
}
